/**
 * Noovera API Contracts
 * Version: 1.0.0
 *
 * This library contains all API contracts (Zod schemas and ts-rest routes)
 * for the Noovera backend API.
 */

import { initContract } from '@ts-rest/core';

// Export all schemas
export * from './schemas/common.schemas';
export * from './schemas/auth.schemas';
export * from './schemas/users.schemas';
export * from './schemas/organizations.schemas';
export * from './schemas/conversations.schemas';
export * from './schemas/agents.schemas';
export * from './schemas/escalations.schemas';
export * from './schemas/analytics.schemas';
export * from './schemas/audit.schemas';
export * from './schemas/integrations.schemas';

// Export individual route contracts
export * from './routes/auth.routes';
export * from './routes/public.routes';
export * from './routes/knowledge.routes';
export * from './routes/tools.routes';
export * from './routes/conversations.routes';
export * from './routes/agents.routes';
export * from './routes/escalations.routes';
export * from './routes/analytics.routes';
export * from './routes/audit.routes';
export * from './routes/integrations.routes';
export { knowledgeContract } from './routes/knowledge.routes';
export { toolsContract } from './routes/tools.routes';

// Import route contracts
import { authContract } from './routes/auth.routes';
import { publicContract } from './routes/public.routes';
import { knowledgeContract } from './routes/knowledge.routes';
import { toolsContract } from './routes/tools.routes';
import { conversationsContract } from './routes/conversations.routes';
import { agentsContract } from './routes/agents.routes';
import { escalationsContract } from './routes/escalations.routes';
import { analyticsContract } from './routes/analytics.routes';
import { auditContract } from './routes/audit.routes';
import { integrationsContract } from './routes/integrations.routes';

// Create main API contract
const c = initContract();

export const apiContract = c.router(
  {
    auth: authContract,
    public: publicContract,
    knowledge: knowledgeContract,
    tools: toolsContract,
    conversations: conversationsContract,
    agents: agentsContract,
    escalations: escalationsContract,
    analytics: analyticsContract,
    audit: auditContract,
    integrations: integrationsContract,
  },
  {
    pathPrefix: '/api/v1',
  },
);

// Export the contract type for use in frontend
export type ApiContract = typeof apiContract;
